import React from 'react';
import { GridItem, Text } from '@chakra-ui/react';
import { ChakraRadio } from 'app/components/Core';

interface ContributionClassNameRadioButtonProps {
  checked?: boolean;
  onChange: () => void;
  title: string;
  description: string;
  value: string;
  disabled?: boolean;
}

interface ContributionClassNameRadioButtonInputProps
  extends React.HTMLAttributes<HTMLDivElement> {
  'data-testid'?: string;
}

export const ContributionClassNameRadioButton: React.FC<ContributionClassNameRadioButtonProps> = ({
  checked,
  onChange,
  title,
  description,
  value,
  disabled,
}) => (
  <GridItem>
    <ChakraRadio
      variant="contained"
      isChecked={checked}
      onChange={onChange}
      value={value}
      isDisabled={disabled}
      inputProps={
        {
          'data-testid': `${value}-radio-input`,
        } as ContributionClassNameRadioButtonInputProps
      }
      px={3}
      py={1}
      width="100%"
      alignItems="flex-start"
      sx={{ my: 'auto', ml: 3 }}
    >
      <>
        <Text pb={1}>{title}</Text>
        <Text
          as="p"
          fontSize="xxs"
          fontWeight={500}
          color="textSubdued"
          overflow="hidden"
          display="-webkit-box"
          sx={{ WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}
        >
          {description}
        </Text>
      </>
    </ChakraRadio>
  </GridItem>
);
